export default (to, from, next) => {
    if (
      localStorage.getItem("userInfo") != null &&
      localStorage.getItem("userInfo").length > 0
    ) {
      next();
    } else {
      console.log("没有userInfo 跳转到登录")
      localStorage.removeItem("userInfo");
      next("/login");
    }

};

